import * as React from "react"
const SvgRight = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M13.181 12.148 9.275 16.05a.95.95 0 0 0-.275.7.95.95 0 0 0 .275.701.95.95 0 0 0 .702.276.95.95 0 0 0 .7-.276l4.608-4.604q.15-.15.213-.325.062-.176.062-.375 0-.2-.063-.376a.9.9 0 0 0-.212-.325l-4.607-4.604a.95.95 0 0 0-.701-.275.95.95 0 0 0-.702.275.95.95 0 0 0-.275.7.95.95 0 0 0 .275.701z" />
  </svg>
)
export default SvgRight
